const Divider = () => {
  return <hr className='my-7 m-auto w-full border-borderGray' />
}

export default Divider
